
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { GiShakingHands } from "react-icons/gi";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
import { IoIosPeople } from "react-icons/io";
import { FaUserPlus } from "react-icons/fa";
 function UpcomingEvents(props) {
    
    return (
<>

        <div className="upComingSection">
            <h3 className='sectionHeading'>Upcoming Events/Get Involved</h3>
            <span className='headingAfterLine'></span>
            <p className='textAfterHeading mb-5'>Join us and make a splash towards excellence! Stay tuned for more details and registration information.</p>
            <div className="iconContainer">
                <div className="eachIconWrap">
                <FaHandHoldingDollar className='eachIcon' />
                <h5>Donate as an individual or corporate</h5>
                </div>
                <div className="eachIconWrap">
                <GiShakingHands className='eachIcon' />
                <h5>Partner through CSR</h5>
                </div>
                <div className="eachIconWrap">
                <FaUsers className='eachIcon' />
                <h5>Offer your expertise</h5>
                </div>
                <div className="eachIconWrap">
                <IoIosPeople className='eachIcon' />
                <h5>Sponsor our conclaves & Events</h5>
                </div>
                <div className="eachIconWrap">
                <FaUserPlus className='eachIcon' />
                <h5>Work with us</h5>
                </div>
            
            </div>
            <Row className='upcomingBox'>
                <Col md={4}>
                    <img src="https://plus.unsplash.com/premium_photo-1664476937285-b99f56a049bd?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="events-image" className='eventImage' />
                </Col>
                <Col md={8}>
                    <h4>Para Swimming Workshop & Competition 2025</h4>
                    <small>(Date: <span className="innerSpan">January 2025</span>, <span>Venue: <span className="innerSpan">Bangalore</span></span>)</small>
                    <p>Dive into a world of possibilities with our upcoming Para Swimming Workshop and Competition! Whether you’re a beginner eager to learn or a seasoned athlete ready to compete, this event is designed to celebrate and nurture talent in para swimming.</p>
                    <h6>Highlights:</h6>
                    <ul>
                        <li>Expert coaching sessions by national and international trainers.</li>
                        <li>Opportunity to compete and showcase your skills.</li>
                        <li>Networking with fellow athletes and sports enthusiasts.</li>
                    </ul>
                </Col>
            </Row>
            {/* <div className="text-center">
                <Button variant="primary" className='showMoreBtn'>Join Us</Button>
            </div> */}
        </div>

</>

    )

}

export default UpcomingEvents
